module.exports = function() {
  return new Worker(__webpack_public_path__ + "worker.load-data.825ca8082ff5c4510299.js");
};